import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { ProtectedRoute } from "@/components/site/ProtectedRoute";
import { TeaPopup } from "@/components/site/TeaPopup";
import Home from "@/pages/Home";
import Ambassadors from "@/pages/Ambassadors";
import ClinicWomb from "@/pages/ClinicWomb";
import University from "@/pages/University";
import Apply from "@/pages/Apply";
import ResetPassword from "@/pages/ResetPassword";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Members from "@/pages/Members";
import Admin from "@/pages/Admin";

const ScrollTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollTop />
        <div className="grain min-h-screen flex flex-col">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/ambassadors" element={<Ambassadors />} />
              <Route path="/clinic" element={<ClinicWomb />} />
              <Route path="/university" element={<University />} />
              <Route path="/apply" element={<Apply />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/members/*" element={<ProtectedRoute><Members /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
            </Routes>
          </main>
          <Footer />
        </div>
        <TeaPopup />
        <Toaster position="top-center" toastOptions={{ style: { background: "#faf7f2", border: "1px solid #dacac1", color: "#232b1b", fontFamily: "Plus Jakarta Sans" } }} />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
